export default __webpack_public_path__ + "static/media/followingAction.6b53c8d1.svg";